import React, {useContext, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import {Grid, Typography, Button} from '@material-ui/core';
import GitHubIcon from '@material-ui/icons/GitHub';

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: theme.spacing(1),
  }
}));

export default function ProjectLink({lutProjectName, dataProjects, id, setHashStateProj, ...props}){
  const classes = useStyles()

  const project = dataProjects[lutProjectName[id]]

  return (<GitHubIcon style={{cursor: 'pointer'}} onClick={e=>setHashStateProj(id)}/>)

  return (
  <Button
    // variant="outlined"
    className={classes.root}
    startIcon={<GitHubIcon/>}
    onClick={e=>setHashStateProj(id)}
    component='div'
  >
    {/* {project.title} */}
    Project
  </Button>
)
}
